import { store } from 'featureSliced/shared/store'

export const isAuth = () => {
  const isLoggedIn = store.getState().auth.isLoggedIn
  return isLoggedIn
}
